export default __webpack_public_path__ + "static/media/kaws2.596c4079.jpg";